import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentCode32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconDocumentCode32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M22 27a2 2 0 0 0 2-2V13h-8V5h-6a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2zm-4-16V5.828L23.172 11zm4 18H10a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h7.172a2 2 0 0 1 1.414.586l6.828 6.828A2 2 0 0 1 26 11.828V25a4 4 0 0 1-4 4M10.793 15.293a1 1 0 0 1 1.414 0l3.536 3.535.707.707-.707.708-3.536 3.535a1 1 0 0 1-1.414-1.414l2.828-2.829-2.828-2.828a1 1 0 0 1 0-1.414M16 23.036a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentCode32);
